import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import {
  Link,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import DataTable from "react-data-table-component";
import moment from "moment";
import swal from "sweetalert";
import { Button, Modal } from "react-bootstrap";
import * as XLSX from "xlsx"; // Import for Excel download
import {
  candidateEmailFilter,
  candidateListAPI,
  candidateStatusChange,
  //deleteCandidate,
  //getReasonList,
} from "../../api/candidate";
import { getAllSkills, getAllIdentity, getAllCities } from "../../api/common";
//import useDebounce from "../../hooks/useDebounce";
import useAccess from "../../api/useAccess";
import SearchInputComponent from "../App/Common/SearchInputComponent";
import {
  download,
  getSelectedColumn,
  sendJobs,
  setSelectColumn,
} from "../../../services/ManageCandidateService";
import { object, string, array } from "yup";
import { jobOrder, updateJobOrder } from "../../../services/JobsService";
import MultiSelect from "../App/Jobs/MultiSelect";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

let jobsOrder = object().shape({
  job_ids: array().required({
    job_ids: "Please select jobs.",
  }),
});

const CandidateLists = () => {
  const optionCount = 60;
  const query = useQuery();
  const [searchParams, setSearchParams] = useSearchParams();
  const lgbt_status_param = searchParams.get("lgbt_status");
  const identify_as_params = searchParams.get("identify_as");
  const reason_param = searchParams.get("reason");
  const filter_param = searchParams.get("filter");
  const { fetchAccess } = useAccess();
  const permission = fetchAccess();

  const { download_access, roleName } = useSelector(
    (state) => state?.auth?.auth
  );

  const paramValue = query.get("type");

  var job_id = "";
  var event_id = "";
  if (paramValue === "event") {
    job_id = "";
    event_id = localStorage.getItem("event_id")
      ? localStorage.getItem("event_id")
      : "";
  } else if (paramValue === "job") {
    job_id = localStorage.getItem("job_id")
      ? localStorage.getItem("job_id")
      : "";
    event_id = "";
  } else {
    job_id = "";
    event_id = "";
  }

  const months = useMemo(() => {
    return [
      { value: 1, label: "January" },
      { value: 2, label: "February" },
      { value: 3, label: "March" },
      { value: 4, label: "April" },
      { value: 5, label: "May" },
      { value: 6, label: "June" },
      { value: 7, label: "July" },
      { value: 8, label: "August" },
      { value: 9, label: "September" },
      { value: 10, label: "October" },
      { value: 11, label: "November" },
      { value: 12, label: "December" },
    ];
  }, []);

  const percentage = useMemo(
    () => [
      { value: "Upto 50.00%", label: "Upto 50.00%" },
      { value: "50.01 to 60.00%", label: "50.01 to 60.00%" },
      { value: "60.01 to 70.00%", label: "60.01 to 70.00%" },
      { value: "70.01 to 80.00%", label: "70.01 to 80.00%" },
      { value: "80.01 to 90.00%", label: "80.01 to 90.00%" },
      { value: "90.01 to 100.00%", label: "90.01 to 100.00%" },
    ],
    []
  );

  const selectOptions = useCallback(() => {
    let options = [];
    for (let index = 0; index <= optionCount; index++) {
      options.push(
        <option value={index} key={index}>
          {index}
        </option>
      );
    }
    return options;
  }, [optionCount]);

  const downlodResume = useCallback((user_id) => {
    download({ user_id: user_id, download_type: "resume" }).then((res) => {
      if (res?.data?.download) {
        window.open(res?.data?.url, "_blank");
      } else {
        swal("Error", res?.data?.message, "error");
      }
    });
  }, []);

  const candidateStatus = useMemo(
    () => [
      { value: 1, title: "CV Shortlisted" },
      { value: 2, title: "Reject" },
      { value: 3, title: "On hold" },
      { value: 4, title: "Offered" },
      { value: 5, title: "DND" },
      { value: 6, title: "Others" },
      { value: 7, title: "In process" },
      { value: 8, title: "Interview Scheduled" },
      { value: 9, title: "Viewed(Action Pending)" },
    ],
    []
  );

  const allClm = useMemo(
    () => [
      {
        clm: "id",
        spec: {
          name: "ID",
          minWidth: "100px",
          maxWidth: "100px",
          selector: (row) => row.id,
          sortable: true,
          wrap: true,
          sortField: "id",
        },
      },
      {
        clm: "resume_file",
        spec: {
          name: "Download Resume file",
          selector: (row) => row.resume_file,
          sortable: false,
          omit: true,
          wrap: false,
          sortField: "resume_file",
        },
      },
      {
        clm: "resume_url",
        spec: {
          name: "Resume",
          selector: (row) => {
            if (row?.resume_file !== undefined) {
              if (row?.resume_file !== "" && row?.resume_file !== null) {
                return (row?.resume_file).includes("site/assets/files") ? (
                  <span className="badge badge-lg light badge-danger">No</span>
                ) : (
                  <span className="badge badge-lg light badge-success">
                    Yes
                  </span>
                );
              } else {
                return (
                  <span className="badge badge-lg light badge-danger">No</span>
                );
              }
            }
            //(row?.resume_file).includes("site/assets/files") ? "No" : "Yes",
          },
          wrap: false,
          sortable: true,
          sortField: "resume_file",
        },
      },
      {
        clm: "legal_name",
        spec: {
          name: "Name",
          selector: (row) => row.legal_name,
          minWidth: "200px",
          maxWidth: "200px",
          sortable: true,
          wrap: true,
          sortField: "legal_name",
        },
      },
      {
        clm: "email",
        spec: {
          name: "Email",
          selector: (row) => row.email,
          minWidth: "200px",
          maxWidth: "200px",
          sortable: true,
          wrap: true,
          sortField: "email",
        },
      },
      {
        clm: "phone_number",
        spec: {
          name: "Phone",
          selector: (row) => row.phone_number,
          minWidth: "200px",
          maxWidth: "200px",
          sortable: true,
          wrap: true,
          sortField: "phone_number",
        },
      },
      {
        clm: "whatsapp_number",
        spec: {
          name: "Whatsapp",
          selector: (row) => row.whatsapp_number,
          minWidth: "200px",
          maxWidth: "200px",
          sortable: true,
          wrap: true,
          sortField: "whatsapp_number",
        },
      },
      {
        clm: "pronoun",
        spec: {
          name: "Pronoun",
          selector: (row) => row.pronoun,
          minWidth: "100px",
          maxWidth: "130px",
          sortable: true,
          wrap: true,
          sortField: "pronoun",
        },
      },
      {
        clm: "current_profile_role",
        spec: {
          name: "Current Job Role",
          selector: (row) => row.current_profile_role,
          minWidth: "250px",
          maxWidth: "250px",
          sortable: true,
          wrap: true,
          sortField: "current_profile_role",
        },
      },
      {
        clm: "current_previous_company",
        spec: {
          name: "Current Employer",
          selector: (row) => row.current_previous_company,
          sortable: true,
          minWidth: "250px",
          maxWidth: "250px",
          wrap: true,
          sortField: "current_previous_company",
        },
      },
      {
        clm: "identify_name",
        spec: {
          name: "Identify As",
          selector: (row) => row.identify,
          minWidth: "150px",
          maxWidth: "150px",
          wrap: true,
          sortable: true,
          sortField: "identify_name",
        },
      },
      {
        clm: "current_location",
        spec: {
          name: "Current Location",
          selector: (row) => row.current_location,
          sortable: true,
          minWidth: "150px",
          maxWidth: "150px",
          wrap: true,
          sortField: "current_location",
        },
      },
      {
        clm: "total_experience_months",
        spec: {
          name: "Experience months",
          selector: (row) => row.total_experience_months,
          sortable: true,
          omit: true,
          wrap: false,
          sortField: "total_experience_months",
        },
      },
      {
        clm: "total_experience_years",
        spec: {
          name: "Experience Years",
          selector: (row) =>
            row.total_experience_years +
            " Years " +
            row.total_experience_months +
            " Month",
          sortable: true,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortField: "total_experience_years",
        },
      },
      {
        clm: "highest_education",
        spec: {
          name: "Qualification",
          selector: (row) => row.highest_education,
          sortable: true,
          minWidth: "250px",
          maxWidth: "250px",
          wrap: true,
          sortField: "highest_education",
        },
      },
      {
        clm: "highest_education_passing_year",
        spec: {
          name: "Year of Passing",
          selector: (row) => row.highest_education_passing_year,
          sortable: true,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortField: "highest_education_passing_year",
        },
      },
      {
        clm: "annual_package",
        spec: {
          name: "Annual package",
          selector: (row) => (row.annual_package === 1 ? "Yes" : "No"),
          sortable: true,
          minWidth: "100px",
          maxWidth: "100px",
          wrap: true,
          sortField: "annual_package",
        },
      },
      {
        clm: "current_salary",
        spec: {
          name: "Current salary",
          selector: (row) => row.current_salary,
          sortable: true,
          minWidth: "150px",
          maxWidth: "150px",
          wrap: true,
          sortField: "current_salary",
        },
      },
      {
        clm: "expected_salary",
        spec: {
          name: "Expected salary",
          selector: (row) => row.expected_salary,
          sortable: true,
          minWidth: "150px",
          maxWidth: "150px",
          wrap: true,
          sortField: "expected_salary",
        },
      },
      {
        clm: "notice_period",
        spec: {
          name: "Notice period",
          selector: (row) => row.notice_period,
          sortable: true,
          minWidth: "100px",
          maxWidth: "100px",
          wrap: true,
          sortField: "notice_period",
        },
      },
      {
        clm: "negotiable",
        spec: {
          name: "Negotiable",
          selector: (row) => (row.negotiable === 1 ? "Yes" : "No"),
          sortable: true,
          minWidth: "100px",
          maxWidth: "100px",
          wrap: true,
          sortField: "negotiable",
        },
      },
      {
        clm: "skills",
        spec: {
          name: "Skills",
          selector: (row) => row.skills,
          sortable: true,
          minWidth: "250px",
          maxWidth: "250px",
          wrap: true,
          sortField: "skills",
        },
      },

      {
        clm: "out_at_work",
        spec: {
          name: "Out at Work",
          selector: (row) =>
            row.out_at_work === 1
              ? "Yes"
              : row.out_at_work === 0
              ? "NO"
              : "N/A",
          sortable: true,
          minWidth: "100px",
          maxWidth: "100px",
          wrap: true,
          sortField: "out_at_work",
        },
      },
      {
        clm: "interested_in_internships",
        spec: {
          name: "Apply for internship",
          selector: (row) =>
            row.interested_in_internships === 1 ? "Yes" : "No",
          sortable: true,
          minWidth: "100px",
          maxWidth: "100px",
          wrap: true,
          sortField: "interested_in_internships",
        },
      },
      {
        clm: "internship_available_months",
        spec: {
          name: "Internship month(s)",
          selector: (row) => row.internship_available_months,
          sortable: true,
          minWidth: "250px",
          maxWidth: "250px",
          wrap: true,
          sortField: "internship_available_months",
        },
      },
      {
        clm: "over_eighteen_years",
        spec: {
          name: "Over eighteen years",
          selector: (row) => (row.over_eighteen_years === 1 ? "Yes" : "No"),
          sortable: true,
          minWidth: "100px",
          maxWidth: "100px",
          wrap: true,
          sortField: "over_eighteen_years",
        },
      },
      {
        clm: "aggregate_percentage",
        spec: {
          name: "Aggregate percentage",
          selector: (row) => row.aggregate_percentage,
          sortable: true,
          minWidth: "150px",
          maxWidth: "150px",
          wrap: true,
          sortField: "aggregate_percentage",
        },
      },
      {
        clm: "date_of_birth",
        spec: {
          name: "Date of birth",
          selector: (row) => row.date_of_birth,
          sortable: true,
          minWidth: "150px",
          maxWidth: "150px",
          wrap: true,
          sortField: "date_of_birth",
        },
      },
      {
        clm: "institution_name",
        spec: {
          name: "College",
          selector: (row) => row.institution_name,
          sortable: true,
          minWidth: "250px",
          maxWidth: "250px",
          wrap: true,
          sortField: "institution_name",
        },
      },
      {
        clm: "lgbt_status",
        spec: {
          name: "LGBT+/Non-LGBT+ Status",
          selector: (row) => row.lgbt_status,
          sortable: true,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortField: "lgbt_status",
        },
      },
      {
        clm: "nonlgbt_gander",
        spec: {
          name: "Non-LGBT Gender",
          selector: (row) => row.nonlgbt_gander || "-",
          sortable: true,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortField: "nonlgbt_gander",
        },
      },
      {
        clm: "candidate_status",
        spec: {
          name: "Candidate status",
          selector: (row) => row.candidate_status,
          sortable: true,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortField: "candidate_status",
        },
      },
      {
        clm: "redacted_resume",
        spec: {
          name: "Redacted resume",
          selector: (row) => row.redacted_resume,
          sortable: true,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortField: "redacted_resume",
        },
      },

      {
        clm: "published",
        spec: {
          name: "Published",
          selector: (row) =>
            row.published === "1" ? (
              <span className="badge badge-lg light badge-success">Active</span>
            ) : (
              <span className="badge badge-lg light badge-danger">
                InActive
              </span>
            ),
          sortable: true,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortField: "published",
        },
      },
      {
        clm: "created_by",
        spec: {
          name: "Created by",
          selector: (row) => (row.created_by === 0 ? "Self" : row.created_by),
          sortable: true,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortField: "created_by",
        },
      },
      {
        clm: "created_at",
        spec: {
          name: "Created at",
          selector: (row) => row.created_at,
          sortable: true,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortField: "created_at",
        },
      },
    ],
    []
  );

  const tableClm = useMemo(
    () => [
      {
        name: "Actions",
        button: "true",
        maxWidth: "230px",
        minWidth: "200px",
        wrap: false,
        cell: (row) => {
          return (
            <>
              {permission?.e === true ? (
                <Link
                  to="#"
                  onClick={(event) => handleEditClick(event, row.id)}
                >
                  <button className="btn btn-warning btn-sm light me-2">
                    <i className="fa fa-edit"></i>
                  </button>
                </Link>
              ) : (
                <></>
              )}
              {permission?.v ? (
                <Link
                  target="_blank"
                  to={`/${row?.id}/view-candidate`}
                  className="btn btn-primary btn-sm light me-2"
                >
                  <i className="fa fa-eye"></i>
                </Link>
              ) : (
                <></>
              )}

              {permission?.dl && row.resume_file === "1" ? (
                <Button
                  //to={row.resume_file}
                  //target="_blank"
                  onClick={() => downlodResume(row?.id)}
                  variant="success"
                  className="btn-sm light me-2"
                >
                  <i className="fa fa-download"></i>
                </Button>
              ) : permission?.dl && row.resume_file === "1" ? (
                <Button
                  //to={row.resume_url}
                  //target="_blank"
                  onClick={() => downlodResume(row?.id)}
                  variant="success"
                  className="btn-sm light me-2"
                >
                  <i className="fa fa-download"></i>
                </Button>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
    ],
    [permission, download_access, downlodResume]
  );

  const AdvanceSearchFields = useMemo(() => {
    return {
      registered_after: "",
      registered_before: "",
      experience_min: "",
      experience_max: "",
      out_at_work: "",
      qualification: "",
      passing_from: "",
      passing_to: "",
      internship_apply: "",
      internship_months: "",
      aggregate_percentage: "",
      ctc_min: "",
      ctc_max: "",
    };
  }, []);

  /* Rm update state start */

  const [jobs, setJobs] = useState([]);
  const [sendJobModel, setSendJobModel] = useState(false);
  const [addModel, setAddModal] = useState(false);
  const [errors, setError] = useState({});
  const [inputData, setInputData] = useState({
    job_ids: [],
  });

  const [data, setData] = useState([]);
  //const [reason, setReason] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [identityList, setIdentityList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [columnModel, setColumnModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRow, setSelectedRows] = useState([]);
  const [selectedColumns, setSelectedColumn] = useState([]);
  const [columns, setColumn] = useState([]);
  const [allColumns] = useState(allClm);
  const [toggleCleared, setToggleCleared] = useState(false);

  const [checkEmailModel, setCheckEmailModel] = useState(false);
  const [checkEmailResponse, setCheckEmailResponse] = useState(null);

  const SearchFields = useMemo(() => {
    return {
      identify_as: "",
      skills: "",
      lgbt_status: "",
      reson: "",
      city: "",
      candidate_status: "",
      job_id: job_id,
      event_id: event_id,
      ...AdvanceSearchFields,
    };
  }, []);

  const [reqParams, setReqParams] = useState({
    ...SearchFields,
    page: currentPage,
    limit: perPage,
    identify_as: identify_as_params ? identify_as_params : "",
    skills: "",
    lgbt_status: lgbt_status_param ? lgbt_status_param : "",
    reson: reason_param ? reason_param : "",
    sort_by: "created_at",
    sort_direction: "DESC",
    city: "",
    candidate_status: "",
    keyword: "",
    filter: filter_param ? filter_param : "",
    job_id: job_id,
    event_id: event_id,
  });

  const [skills, setSkills] = useState([]);
  const [locations, setLocations] = useState([]);
  const [identities, setIdentities] = useState([]);

  const [advFields, setAdvFields] = useState(SearchFields);
  const [advanceParams, setAdvanceParams] = useState(SearchFields);
  const [clearAdvanceSearch, setClearAdvanceSearch] = useState(false);

  const [fetch, setFetch] = useState(true);
  const ipRef = useRef();
  /* Rm update state end */

  useEffect(() => {
    if (columns.length < 1 && permission?.v) {
      setColumn(tableClm);
      handleFetchColumns(permission, download_access);
    }
  }, [columns, permission, download_access]);

  const navigate = useNavigate();

  const fetchUsers = useCallback(
    (params) => {
      setToggleCleared(!toggleCleared);
      setLoading(true);
      candidateListAPI(params)
        .then((res) => {
          setData(res?.data);
          setTotalRows(res?.total);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          //console.log(err);
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch, toggleCleared]
  );

  const getActions = useCallback(
    (permission, download_access) => {
      return {
        name: "Actions",
        button: "true",
        maxWidth: "230px",
        minWidth: "200px",
        wrap: false,
        cell: (row) => {
          return (
            <>
              {permission?.e === true ? (
                <Link
                  to="#"
                  onClick={(event) => handleEditClick(event, row.id)}
                >
                  <button className="btn btn-warning btn-sm light me-2">
                    <i className="fa fa-edit"></i>
                  </button>
                </Link>
              ) : (
                <></>
              )}
              {permission?.v ? (
                <Link
                  target="_blank"
                  to={`/${row?.id}/view-candidate`}
                  className="btn btn-primary btn-sm light me-2"
                >
                  <i className="fa fa-eye"></i>
                </Link>
              ) : (
                <></>
              )}

              {permission?.dl && row.resume_file === "1" ? (
                <Button
                  //to={row.resume_file}
                  //target="_blank"
                  onClick={() => downlodResume(row?.id)}
                  className="btn-sm light me-2"
                  variant="success"
                >
                  <i className="fa fa-download"></i>
                </Button>
              ) : permission?.dl && row.resume_file === "1" ? (
                <Button
                  //to={row.resume_url}
                  //target="_blank"
                  onClick={() => downlodResume(row?.id)}
                  variant="success"
                  className="btn-sm light me-2"
                >
                  <i className="fa fa-download"></i>
                </Button>
              ) : (
                <></>
              )}
            </>
          );
        },
      };
    },
    [permission, download_access, downlodResume]
  );

  const handleFetchColumns = useCallback(
    (permission, download_access) => {
      getSelectedColumn("admin")
        .then((resp) => {
          if (
            resp.data?.search_keys !== undefined &&
            resp.data?.search_keys !== ""
          ) {
            let keys = resp.data?.search_keys;
            let keyArray = keys ? keys.split(",") : [];
            setSelectedColumn(keyArray);

            let newTableColumn = [getActions(permission, download_access)];
            allColumns.forEach((clm, i) => {
              if (keyArray.includes(clm?.clm)) {
                newTableColumn.push(clm?.spec);
              }
              return false;
            });

            setColumn(newTableColumn);

            setFetch(true);
          } else {
            setFetch(true);
          }
        })
        .catch((err) => console.log(err));
    },
    [setFetch, columns]
  );

  const formatOptionList = useCallback((res, label, value, callback) => {
    if (res.length > 0) {
      let optionArray = [];
      res.forEach((obj, i) => {
        optionArray.push({ value: obj[value], label: obj[label] });
      });
      callback(optionArray);
    }
  }, []);

  const fetchJobs = useCallback(() => {
    jobOrder()
      .then((res) => {
        formatOptionList(res?.data, "job_title", "id", setJobs);
      })
      .catch((err) => console.log(err));
  }, [setJobs, formatOptionList]);

  useEffect(() => {
    fetchJobs();
  }, []);

  useEffect(() => {
    if (fetch) {
      let reqData = {};
      if (clearAdvanceSearch) {
        reqData = { ...reqParams, ...advanceParams };
      } else {
        reqData = { ...advanceParams, ...reqParams };
      }
      fetchUsers(reqData);
    }
  }, [fetch, reqParams, advanceParams, clearAdvanceSearch]);

  const handleSearchText = useCallback(
    (text, isClear = false) => {
      if (text || isClear) {
        setReqParams((state) => {
          return { ...state, keyword: text };
        });
        setFetch(true);
      }
    },
    [setReqParams, setFetch]
  );

  const isValidEmailOrMobile = useCallback((input) => {
    // Basic email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Indian mobile number regex: starts with 6-9 and 10 digits
    const mobileRegex = /^[6-9]\d{9}$/;
    return emailRegex.test(input) || mobileRegex.test(input);
  }, []);

  const onCheckEmail = useCallback(() => {
    if (ipRef?.current.value !== "") {
      if (isValidEmailOrMobile(ipRef?.current.value)) {
        candidateEmailFilter({ email: ipRef?.current.value }).then((res) => {
          setCheckEmailResponse(res?.data);
        });
      } else {
        swal("Error", "Please enter valid Email/Phone number.", "error");
      }
    } else {
      swal("Error", "Please enter value to filter.", "error");
    }
  }, [ipRef]);

  const handleSelectColumn = useCallback(() => {
    const checks = document.getElementsByClassName("column-check-box");
    let selectedChecks = [];
    for (let i = 0; i < checks.length; i++) {
      if (document.getElementsByClassName("column-check-box")[i].checked) {
        selectedChecks.push(
          document.getElementsByClassName("column-check-box")[i].value
        );
      }
    }

    setSelectedColumn(selectedChecks);

    let newTableColumn = [getActions(permission)];
    allColumns.forEach((clm, i) => {
      if (selectedChecks.includes(clm?.clm)) {
        newTableColumn.push(clm?.spec);
      }
    });

    setColumn(newTableColumn);

    setSelectColumn(selectedChecks, "admin")
      .then((resp) => {
        setFetch(true);
      })
      .catch((error) => swal("Opps", error.message, "error"));
    setColumnModal(false);
  }, [allColumns, columns, setColumn, setFetch, permission]);

  const checkAll = useCallback((isChecked) => {
    let list = document.getElementsByClassName("tbl-columns");
    if (isChecked) {
      for (let i = 0; i < list.length; i++) {
        document.getElementsByClassName("tbl-columns")[i].checked = true;
      }
    } else {
      for (let i = 0; i < list.length; i++) {
        document.getElementsByClassName("tbl-columns")[i].checked = false;
      }
    }
  }, []);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
        page: 1,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  useEffect(() => {
    setSkillIdentity();
  }, []);

  const setSkillIdentity = async () => {
    let s = await getAllSkills();
    formatOptionList(s, "skill_title", "id", setSkills);
    let ident = await getAllIdentity();
    formatOptionList(ident, "identify_name", "id", setIdentities);
    let c = await getAllCities();
    formatOptionList(c, "city_name", "id", setLocations);

    setSkillList(s);

    setIdentityList(ident);
    setCitiesList(c);
  };

  const handleEditClick = async (event, id) => {
    event.preventDefault();
    localStorage.setItem("nid", id);
    window.open("/edit_candidate", "_blank");
  };

  const handleIdentifyAsChange = useCallback(
    (event) => {
      setReqParams({ ...reqParams, identify_as: event.target.value, page: 1 });
      setCurrentPage(1);
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleSkillsChange = useCallback(
    (event) => {
      setReqParams({ ...reqParams, skills: event.target.value, page: 1 });
      setCurrentPage(1);
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleCandidateStatusChange = useCallback(
    (event) => {
      setReqParams({
        ...reqParams,
        candidate_status: event.target.value,
        page: 1,
      });
      setCurrentPage(1);
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleCityChange = useCallback(
    (event) => {
      setReqParams({
        ...reqParams,
        city: event.target.value,
        page: 1,
      });
      setCurrentPage(1);
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleLgbtStatus = useCallback(
    (event) => {
      setReqParams({
        ...reqParams,
        lgbt_status: event.target.value,
        page: 1,
      });
      setCurrentPage(1);
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleReason = useCallback(
    (event) => {
      setReqParams({
        ...reqParams,
        reson: event.target.value,
        page: 1,
      });
      setCurrentPage(1);
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleApplications = useCallback(
    (event) => {
      setReqParams({
        ...reqParams,
        filter: event.target.value,
        page: 1,
      });
      setCurrentPage(1);
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleCopy = () => {
    const text = data.map((job) => Object.values(job).join("\t")).join("\n");
    navigator.clipboard.writeText(text).then(() => {
      swal("Copied!", "Table data copied to clipboard.", "success");
    });
  };

  const handleDownloadExcel = () => {
    download({
      user_id: "",
      download_type: "excel",
      total_records: reqParams?.limit,
      module_name: "candidate",
    }).then((res) => {
      if (res?.data?.download) {
        const displayedData = data.map((Event) => {
          let evnt = { ...Event };
          if (evnt?.over_eighteen_years !== undefined) {
            evnt.over_eighteen_years =
              evnt?.over_eighteen_years === 1 ? "Yes" : "No";
          }
          if (evnt?.annual_package !== undefined) {
            evnt.annual_package = evnt?.annual_package === 1 ? "Yes" : "No";
          }
          if (evnt?.out_at_work !== undefined) {
            evnt.out_at_work =
              evnt?.out_at_work === 1
                ? "Yes"
                : evnt.out_at_work === 0
                ? "No"
                : "N/A";
          }
          if (evnt?.interested_in_internships !== undefined) {
            evnt.interested_in_internships =
              evnt?.interested_in_internships === 1 ? "Yes" : "No";
          }
          if (evnt?.published !== undefined) {
            evnt.published = evnt?.published == "1" ? "Active" : "InActive";
          }
          if (evnt?.created_by !== undefined) {
            evnt.created_by = evnt?.created_by === 0 ? "Self" : evnt.created_by;
          }
          if (evnt?.created_at !== undefined) {
            var today = moment();
            var createdDate = moment(evnt?.created_at);
            evnt.days = today.diff(createdDate, "days");
          }
          return evnt;
        });
        const worksheet = XLSX.utils.json_to_sheet(displayedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Jobs");
        XLSX.writeFile(workbook, "CandidateList.xlsx");
      } else {
        swal("Error", res?.data?.message, "error");
      }
    });
  };

  const handleViewClick = async (event, id) => {
    event.preventDefault();
    localStorage.setItem("vid", id);
    navigate("/candidate_view");
  };

  const handleChangeStatus = useCallback(
    async (e) => {
      if (e.target.value === "") return;
      let statusToUpdate = e.target.value === "1" ? "Active" : "Inactive";

      const candidate = selectedRow.map((c, i) => {
        return c.id;
      });

      if (candidate.length < 1) {
        swal(
          "Opps",
          `Please select at least 1 candidate to ${statusToUpdate}.`,
          "error"
        );
        return false;
      }

      const willDelete = await swal({
        title: "Are you sure?",
        text: `Do you want to ${statusToUpdate} selected candidates ?`,
        icon: "warning",
        dangerMode: true,
        buttons: true,
        //content: span,
      });
      if (willDelete) {
        let postData = {
          status: e.target.value,
          candidate_id: candidate.join(","),
        };
        e.target.value = "";
        await candidateStatusChange(postData);
        setSelectedRows([]);
        setFetch(true);
        swal(statusToUpdate, `Record has been ${statusToUpdate}!`, "success");
      }
    },
    [selectedRow, setFetch]
  );

  const updateDownloadStatus = (id) => {
    console.log("Update download id", id);
  };

  const onClickDelete = (id) => {
    //handleDeleteClick(id);
  };

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  const handleMultiSelect = useCallback(
    (values, inputname) => {
      if (values?.length > 0) {
        let ids = [];
        values.forEach((element, i) => {
          ids.push(element?.value);
        });
        setInputData({
          ...inputData,
          [inputname]: ids,
        });
      } else {
        setInputData({
          ...inputData,
          [inputname]: "",
        });
      }
    },
    [inputData, setInputData]
  );

  const handleSearchMultiSelect = useCallback(
    (values, inputname) => {
      if (values?.length > 0) {
        setAdvFields({ ...advFields, [inputname]: values });
      } else {
        setAdvFields({ ...advFields, [inputname]: "" });
      }
    },
    [advFields, setAdvFields]
  );

  const handleAdd = useCallback(() => {
    const candidate = selectedRow.map((c, i) => {
      return c.id;
    });

    jobsOrder
      .validate(inputData, { strict: false, abortEarly: false })
      .then((resp) => {
        setError({});
        const postData = { ...inputData, candidate_ids: candidate };
        sendJobs(postData)
          .then((response) => {
            swal("Great Job!", response?.data.message, "success");
            setSendJobModel(false);
            setSelectedRows([]);
            setFetch(true);
          })
          .catch((e) => console.log(e));
      })
      .catch((err) => {
        let errObj = {};
        err.errors.map((msg, i) => {
          let keys = Object.keys(msg);
          if (errObj[keys[0]] === undefined) {
            errObj = { ...errObj, [keys[0]]: msg[keys[0]] };
          }
          return null;
        });
        setError(errObj);
      });
  }, [inputData, setToggleCleared, selectedRow]);

  const handleSendJob = useCallback(() => {
    if (selectedRow.length < 1) {
      swal("Opps", `Please select at least 1 candidate to send job.`, "error");
      return false;
    }
    setSendJobModel(true);
  }, [selectedRow, setSendJobModel]);

  const getMultiSelectValue = useCallback((values) => {
    if (values && values?.length > 0) {
      let ids = [];
      values.forEach((element, i) => {
        ids.push(element?.value);
      });
      return ids.toString();
    }
    return "";
  }, []);

  const onSaveAdvanceSearch = useCallback(() => {
    setReqParams({
      ...reqParams,
      identify_as: "",
      city: "",
      lgbt_status: "",
      skills: "",
      candidate_status: "",
      reson: "",
      keyword: "",
      filter: "",
      page: 1,
    });
    setAdvanceParams({
      ...advFields,
      registered_after:
        advFields.registered_after !== ""
          ? moment(advFields?.registered_after).format("yyyy-MM-DD")
          : "",
      registered_before:
        advFields.registered_before !== ""
          ? moment(advFields?.registered_before).format("yyyy-MM-DD")
          : "",
      skills: getMultiSelectValue(advFields?.skills),
      city: getMultiSelectValue(advFields?.city),
      internship_months: getMultiSelectValue(advFields?.internship_months),
      aggregate_percentage: getMultiSelectValue(
        advFields?.aggregate_percentage
      ),
    });
    setClearAdvanceSearch(true);
    setAddModal(false);
    setFetch(true);
  }, [
    setReqParams,
    reqParams,
    setAdvanceParams,
    advFields,
    setFetch,
    setClearAdvanceSearch,
    setAddModal,
    getMultiSelectValue,
  ]);

  const onClearAdvanceSearch = useCallback(() => {
    setReqParams({ ...reqParams, page: 1 });
    setClearAdvanceSearch(false);
    setAdvFields(SearchFields);
    setAdvanceParams(SearchFields);
    setFetch(true);
  }, [
    setReqParams,
    reqParams,
    setClearAdvanceSearch,
    SearchFields,
    setAdvanceParams,
    setAdvFields,
    setFetch,
  ]);

  const selectYearsOptions = useCallback(() => {
    let options = [];
    for (let index = Number(moment().year()+3); index >= 1960; index--) {
      options.push(
        <option value={index} key={index}>
          {index}
        </option>
      );
    }
    return options;
  }, []);

  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600 me-auto">{""}</h4>
        {clearAdvanceSearch && (
          <button
            onClick={onClearAdvanceSearch}
            className="btn btn-danger me-3 btn-sm"
          >
            <i className="fas fa-times me-1"></i>Reset
          </button>
        )}
        <button
          onClick={() => setAddModal(true)}
          className="btn btn-info me-3 btn-sm"
        >
          <i className="fas fa-search me-1"></i>Search
        </button>
        <button
          onClick={() => {
            setCheckEmailModel(true);
            setCheckEmailResponse(null);
          }}
          className="btn btn-success me-3 btn-sm"
        >
          <i className="fas fa-search me-1"></i>Check Candidate
        </button>
        {(roleName === "Super Admin" || permission.vac) && (
          <button
            onClick={handleSendJob}
            className="btn btn-warning me-3 btn-sm"
          >
            Send Jobs
          </button>
        )}
        <button
          onClick={() => setColumnModal(true)}
          className="btn btn-secondary me-3 btn-sm"
        >
          Select Column
        </button>
        {paramValue == null && permission.a === true ? (
          <>
            <Link to={"/upload_candidate"} className="btn btn-primary btn-sm">
              <i className="fas fa-plus me-2"></i>Upload Candidate
            </Link>
          </>
        ) : (
          <></>
        )}
      </div>
      <div className="row">
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={reqParams?.city}
            onChange={handleCityChange}
          >
            <option value="">Filter by City</option>
            {citiesList?.map((item) => {
              return (
                <option key={item.id} value={item.id}>
                  {item.city_name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={reqParams?.identify_as}
            onChange={handleIdentifyAsChange}
          >
            <option value="">Filter by Identify As</option>
            {identityList?.map((item) => {
              return (
                <option key={item.id} value={item.id}>
                  {item.identify_name}
                </option>
              );
            })}
            <option value="15">Man</option>
            <option value="16">Woman</option>
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={reqParams?.skills}
            onChange={handleSkillsChange}
          >
            <option value="">Filter by Skills</option>
            {skillList?.map((item) => {
              return (
                <option key={item.id} value={item.id}>
                  {item.skill_title}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={reqParams?.candidate_status}
            onChange={handleCandidateStatusChange}
          >
            <option value="">Filter by Candidate Status</option>
            <option value="1">CV Shortlisted</option>
            <option value="2">Reject</option>
            <option value="3">On hold</option>
            <option value="4">Offered</option>
            <option value="5">DND</option>
            <option value="6">Others</option>
            <option value="7">In process</option>
            <option value="8">Interview Scheduled</option>
            <option value="9">Viewed(Action Pending)</option>
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={reqParams?.lgbt_status}
            onChange={handleLgbtStatus}
          >
            <option value="">Filter by LGBT Status</option>
            <option value="0">Pending</option>
            <option value="1">Confirmed</option>
            {/* <option value="2">Rejected</option> */}
            <option value="3">Non-LGBT</option>
            <option value="4">Other</option>
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={reqParams?.reson}
            onChange={handleReason}
          >
            <option value="">Filter by Inactive status</option>

            <option value="Not Verified">Not Verified</option>
            <option value="Candidate Request">Candidate Request</option>
            <option value="Blacklisted">Blacklisted</option>
            <option value="Hold for 3 Months (Job Secured)">
              Hold for 3 Months (Job Secured)
            </option>
            <option value="CV Not Received">CV Not Received</option>
            <option value="Non-LGBT">Non-LGBT</option>
            <option value="Invalid Profile Data">Invalid Profile Data</option>
            <option value="Candidate Delete Request">
              Candidate Delete Request
            </option>
          </select>
        </div>
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={reqParams?.filter}
            onChange={handleApplications}
          >
            <option value="">Filter by Applications</option>
            <option value="today">Applications Today</option>
            <option value="no-resume">No Resume</option>
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-10 mb-2">
              <select
                className="btn btn-success me-3"
                onChange={handleChangeStatus}
              >
                <option value="">Change status</option>
                <option value="1">Active</option>
                <option value="1,1">Active (LGBT Confirmed)</option>
                <option value="0,Not Verified">InActive (Not Verified)</option>
                <option value="0,Candidate Request">
                  InActive (Candidate Request)
                </option>
                <option value="0,Blacklisted">InActive (Blacklisted)</option>
                <option value="0,Hold for 3 Months (Job Secured)">
                  InActive (Hold for 3 Months (Job Secured))
                </option>
                <option value="0,CV Not Received">
                  InActive (CV Not Received)
                </option>
                <option value="0,Non-LGBT">Non-LGBT</option>
                <option value="0,Invalid Profile Data">
                  Invalid Profile Data
                </option>
              </select>
              {download_access && (
                <>
                  <button
                    className="btn btn-secondary me-3"
                    onClick={handleCopy}
                  >
                    COPY
                  </button>
                  <button
                    className="btn btn-warning"
                    onClick={handleDownloadExcel}
                  >
                    Download Excel
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              paginationResetDefaultPage={reqParams?.page === 1}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
              selectableRows
              persistTableHead
              subHeader
              //conditionalRowStyles={conditionalRowStyles}
              subHeaderComponent={
                <SearchInputComponent setFilterText={handleSearchText} />
              }
              clearSelectedRows={toggleCleared}
              onSelectedRowsChange={({ selectedRows }) =>
                setSelectedRows(selectedRows)
              }
              onSort={handleSort}
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>

      <Modal
        className="modal fade"
        size="lg"
        show={columnModel}
        backdrop="static"
        onHide={setColumnModal}
      >
        <div role="document">
          <div className="">
            <div className="modal-header">
              <h4 className="modal-title fs-20">Select columns to be shown.</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setColumnModal(false)}
                data-dismiss="modal"
              >
                <span></span>
              </button>
            </div>
            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
              <div className="add-contact-box">
                <div className="add-contact-content" id="setColumn">
                  <div className="row">
                    {allColumns.map((column, i) => {
                      return (
                        <div className="col-md-4 form-group" key={i}>
                          <input
                            id={column?.clm}
                            className="form-check-input tbl-columns column-check-box"
                            type="checkbox"
                            value={column?.clm}
                            defaultChecked={selectedColumns.includes(
                              column?.clm
                            )}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={column?.clm}
                          >
                            {column.spec.name}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                  <div className="row">
                    <div className="col-md-4 form-group">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="select-all"
                        onChange={(e) => {
                          checkAll(e.target.checked);
                        }}
                      />
                      <label className="form-check-label" htmlFor="select-all">
                        Select All
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-success"
                onClick={handleSelectColumn}
              >
                Save
              </button>
              <button
                type="button"
                onClick={() => setColumnModal(false)}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i> Close
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        className="modal fade"
        size="lg"
        show={sendJobModel}
        backdrop="static"
        onHide={setSendJobModel}
      >
        <div role="document">
          <div className="">
            <div className="modal-header">
              <h4 className="modal-title fs-20">Select Jobs to send.</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setSendJobModel(false)}
                data-dismiss="modal"
              >
                <span></span>
              </button>
            </div>
            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
              <div className="add-contact-box">
                <div className="add-contact-content" id="setColumn">
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="mb-3 form-group">
                        <label htmlFor="locations">
                          Select Jobs<span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <MultiSelect
                          create={false}
                          multiple={true}
                          options={jobs}
                          onValueSelect={handleMultiSelect}
                          name="job_ids"
                        />
                        {errors?.job_ids !== undefined && (
                          <div className="invalid-feedback d-block">
                            {errors?.job_ids}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleAdd}
              >
                Save
              </button>
              <button
                type="button"
                onClick={() => setSendJobModel(false)}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i> Close
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        className="modal fade"
        size="lg"
        show={addModel}
        backdrop="static"
        onHide={setAddModal}
      >
        <div role="document">
          <div className="modal-header">
            <h4 className="modal-title fs-20">Search</h4>
            <button
              type="button"
              className="btn-close"
              onClick={() => setAddModal(false)}
              data-dismiss="modal"
            >
              <span></span>
            </button>
          </div>
          <div className="modal-body p-1">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">
                      Register after
                    </label>
                    <div className="mb-1 form-group">
                      <DatePicker
                        className={`form-control`}
                        wrapperClassName="d-inline"
                        dateFormat="Y-MM-dd"
                        maxDate={new Date()}
                        peekNextMonth
                        isClearable
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Select date"
                        //selected={advFields?.registered_after}
                        onFocus={(e) => e.target.blur()}
                        selected={
                          advFields?.registered_after
                            ? advFields?.registered_after
                            : ""
                        }
                        onChange={(date) => {
                          setAdvFields({
                            ...advFields,
                            registered_after: date ? date : "",
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">
                      Register before
                    </label>
                    <div className=" mb-1 form-group">
                      <DatePicker
                        className={`form-control`}
                        wrapperClassName="d-inline"
                        dateFormat="Y-MM-dd"
                        maxDate={new Date()}
                        isClearable
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Select date"
                        //selected={advFields?.registered_after}
                        onFocus={(e) => e.target.blur()}
                        selected={
                          advFields?.registered_before
                            ? advFields?.registered_before
                            : ""
                        }
                        onChange={(date) => {
                          setAdvFields({
                            ...advFields,
                            registered_before: date ? date : "",
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">
                      Experience min
                    </label>
                    <div className="input-group mb-1 form-group">
                      <select
                        id="experience_min"
                        className="form-select"
                        type="text"
                        name="experience_min"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            experience_min: e.target.value,
                          })
                        }
                        defaultValue={advFields?.experience_min}
                      >
                        <option value="">Please Select</option>
                        {selectOptions()}
                      </select>
                      <span className="input-group-text" id="basic-addon1">
                        Years
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">
                      Experience max
                    </label>
                    <div className="input-group mb-1 form-group">
                      <select
                        id="experience_max"
                        className="form-select"
                        type="text"
                        name="experience_max"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            experience_max: e.target.value,
                          })
                        }
                        defaultValue={advFields?.experience_max}
                      >
                        <option value="">Please Select</option>
                        {selectOptions()}
                      </select>
                      <span className="input-group-text" id="basic-addon1">
                        Years
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">Identify as</label>
                    <div className="input-group mb-1 form-group">
                      <select
                        id="identify_as"
                        className="form-select"
                        type="text"
                        name="identify_as"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            identify_as: e.target.value,
                          })
                        }
                        defaultValue={advFields?.identify_as}
                      >
                        <option value="">Please Select</option>
                        {identities.map((identity, i) => (
                          <option value={identity.value} key={i}>
                            {identity.label}
                          </option>
                        ))}
                        <option value="15">Man</option>
                        <option value="16">Woman</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="adv_out_at_work">OUT at work?</label>
                    <div className="input-group mb-1 form-group">
                      <select
                        id="out_at_work"
                        className="form-select"
                        type="text"
                        name="out_at_work"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            out_at_work: e.target.value,
                          })
                        }
                        defaultValue={advFields?.out_at_work}
                      >
                        <option value="">Please Select</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="ctc_min">CTC Min.</label>
                    <div className="input-group mb-1 form-group">
                      <input
                        type="number"
                        name="ctc_min"
                        id="ctc_min"
                        className="form-control form-control-sm"
                        placeholder="CTC Min."
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            ctc_min: e.target.value,
                          })
                        }
                        defaultValue={advFields?.ctc_min}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="ctc_max">CTC Max.</label>
                    <div className="input-group mb-1 form-group">
                      <input
                        type="number"
                        name="ctc_max"
                        id="ctc_max"
                        className="form-control form-control-sm"
                        placeholder="CTC Max."
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            ctc_max: e.target.value,
                          })
                        }
                        defaultValue={advFields?.ctc_max}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="qualification">Qualification</label>
                    <div className="input-group mb-1 form-group">
                      <input
                        type="text"
                        name="qualification"
                        id="qualification"
                        className="form-control form-control-sm"
                        placeholder="Qualification"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            qualification: e.target.value,
                          })
                        }
                        defaultValue={advFields?.qualification}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="passing_from">Year of pass from</label>
                    <div className="input-group mb-3 form-group">
                      <select
                        id="passing_from"
                        className="form-select"
                        type="text"
                        name="passing_from"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            passing_from: e.target.value,
                          })
                        }
                        defaultValue={advFields?.passing_from}
                      >
                        <option value="">Select Year</option>
                        {selectYearsOptions()}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="passing_to">Year of pass to</label>
                    <div className="input-group mb-3 form-group">
                      <select
                        id="passing_to"
                        className="form-select"
                        type="text"
                        name="passing_to"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            passing_to: e.target.value,
                          })
                        }
                        defaultValue={advFields?.passing_to}
                      >
                        <option value="">Select Year</option>
                        {selectYearsOptions()}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="skills">Skills</label>
                    <div className="mb-3 form-group">
                      <MultiSelect
                        multiple={true}
                        options={skills}
                        onValueSelect={handleSearchMultiSelect}
                        selected={advFields?.skills}
                        name="skills"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="city">Current City</label>
                    <div className="mb-3 form-group">
                      <MultiSelect
                        multiple={true}
                        options={locations}
                        onValueSelect={handleSearchMultiSelect}
                        selected={advFields?.city}
                        name="city"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="internship_apply">Internship Apply</label>
                    <div className="input-group mb-3 form-group">
                      <select
                        id="internship_apply"
                        className="form-select"
                        type="text"
                        name="internship_apply"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            internship_apply: e.target.value,
                          })
                        }
                        defaultValue={advFields?.internship_apply}
                      >
                        <option value="">Select</option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="internship_months">
                      Internship Month(s)
                    </label>
                    <div className="mb-3 form-group">
                      <MultiSelect
                        multiple={true}
                        options={months}
                        onValueSelect={handleSearchMultiSelect}
                        selected={advFields?.internship_months}
                        name="internship_months"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="lgbt_status">LGBT+ Verification</label>
                    <div className="input-group mb-3 form-group">
                      <select
                        id="lgbt_status"
                        className="form-select"
                        type="text"
                        name="lgbt_status"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            lgbt_status: e.target.value,
                          })
                        }
                        defaultValue={advFields?.lgbt_status}
                      >
                        <option value="">Select</option>
                        <option value="0">Pending</option>
                        <option value="1">Confirmed</option>
                        <option value="3">Non-LGBT</option>
                        <option value="4">Other</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {/* <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="internship_months">
                      Internship Month(s)
                    </label>
                    <div className="mb-3 form-group">
                      <MultiSelect
                        multiple={true}
                        options={months}
                        onValueSelect={handleSearchMultiSelect}
                        name="internship_months"
                      />
                    </div>
                  </div>
                </div> */}
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="aggregate_percentage">
                      Aggregate Percentage
                    </label>
                    <div className="mb-3 form-group">
                      <MultiSelect
                        multiple={true}
                        options={percentage}
                        onValueSelect={handleSearchMultiSelect}
                        name="aggregate_percentage"
                        selected={advFields?.aggregate_percentage}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="candidate_status">Candidate Status</label>
                    <div className="input-group mb-3 form-group">
                      <select
                        id="candidate_status"
                        className="form-select"
                        type="text"
                        name="candidate_status"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            candidate_status: e.target.value,
                          })
                        }
                        defaultValue={advFields?.candidate_status}
                      >
                        <option value="">Please Select</option>
                        {candidateStatus.map((status, i) => (
                          <option value={status.value} key={i}>
                            {status.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="submit"
              className="btn btn-success"
              onClick={onSaveAdvanceSearch}
            >
              Search
            </button>
            <button
              type="button"
              onClick={() => setAddModal(false)}
              className="btn btn-danger"
            >
              <i className="flaticon-delete-1"></i> Close
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        className="modal fade"
        size="lg"
        show={checkEmailModel}
        backdrop="static"
        onHide={() => {
          setCheckEmailModel(false);
        }}
      >
        <div role="document">
          <div className="">
            <div className="modal-header">
              <h4 className="modal-title fs-20">
                Check Candidate By Email/Phone
              </h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setCheckEmailModel(false)}
                data-dismiss="modal"
              >
                <span></span>
              </button>
            </div>
            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
              <div className="add-contact-box">
                <div className="add-contact-content" id="setColumn">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="mb-3 form-group">
                        <label htmlFor="locations">
                          Email/Phone <span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          ref={ipRef}
                          id="Email/Phone"
                          onChange={() => {
                            setCheckEmailResponse(null);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      {checkEmailResponse !== null && (
                        <h5
                          className={
                            checkEmailResponse?.found
                              ? "text-success"
                              : "text-danger"
                          }
                        >
                          {checkEmailResponse?.message}
                        </h5>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={onCheckEmail}
              >
                Search
              </button>
              <button
                type="button"
                onClick={() => setCheckEmailModel(false)}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i> Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CandidateLists;
